import React from "react";
import PageHeaderLayout from "../../../../layout/pageHeaderLayout";
import useAntTable from "../../../../utils/useAntTable";
import * as api from "../../../../apis/platforms/admin/financeRefund";
import StandardTable, {StandardColumnsType} from "../../../../components/StandardTable";
import {useHistory} from "react-router-dom";
import dayjs from "dayjs";

export default function FinanceRefund() {

    const history = useHistory()
    const {tableProps, search, form} = useAntTable(api.getFinanceRefundList, {method: "post"})

    const columns = [
        {
            title: '退款编号',
            dataIndex: 'refundNo'
        },
        {
            title: '客户名称',
            dataIndex: 'dealerName'
        },
        {
            title: '退款日期',
            dataIndex: 'refundDate',
            render: (value: any) => dayjs(value).format('ll')
        },
        {
            title: '退款金额',
            dataIndex: 'refundAmount'
        },
        {
            title: '已核销金额',
            dataIndex: 'writeOffAmount'
        },
        {
            title: '单据类型',
            dataIndex: 'refundType'
        },
        {
            title: '退款说明',
            dataIndex: 'refundDesc'
        },
        {
            title: '核销状态',
            dataIndex: 'writeOffStatus',
            render: (_: any, record: any) => {
                if (record.writeOffAmount === 0) {
                    return '未核销'
                } else if (record.writeOffAmount < record.refundAmount) {
                    return '部分核销'
                } else {
                    return '已核销'
                }
            }
        },
        {
            title: '操作',
            dataIndex: 'operation',
            render: (_: any, record: any) => (
                <span>
                    <a onClick={() => history.push(`/finance/refund/detail/${record.id}`)}>详情</a>
                </span>
            )
        }
    ]

    const extSearchColumns: StandardColumnsType = [
        {
            dataIndex: 'receiptNo',
            title: '退款编号',
            search: {
                colSpan: 6
            }
        },
        {
            dataIndex: 'dealer',
            title: '客户名称或编号',
            search: {
                colSpan: 6
            }
        },
        {
            title: '日期范围',
            dataIndex: 'dateRange',
            search: {
                valueType: 'dateRange',
                colSpan: 6
            }
        },
        {
            dataIndex: 'status',
            title: '状态',
            search: {
                valueType: 'select',
                valueEnum: [
                    {value: 0, text: '未核销'},
                    {value: 10, text: '部分核销'},
                    {value: 20, text: '已核销'},
                ],
                colSpan: 6
            }
        }
    ];

    return (
        <PageHeaderLayout>
            <StandardTable rowKey={'id'} columns={columns} {...tableProps} extSearchColumns={extSearchColumns}
                           search={search} form={form}/>
        </PageHeaderLayout>
    )
}
